import { render } from "./SocialList.vue?vue&type=template&id=c5514834&scoped=true"
import script from "./SocialList.vue?vue&type=script&lang=js"
export * from "./SocialList.vue?vue&type=script&lang=js"

import "./SocialList.vue?vue&type=style&index=0&id=c5514834&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5514834"]])

export default __exports__